import React from 'react'

export default class GruposCombo extends React.Component {
  render () {
    return (
      <div className="card-text">
        <label className="string required">
          <abbr title="obrigatório">*</abbr> Dividir horário para agendamento
        </label>
        &nbsp;
        <a data-bs-toggle="modal"
           data-bs-target="#legenda_grupos"
           href="#"
           onClick={(e) => e.preventDefault()}>
          <small>O que é isso?</small>
        </a>

        <div className="form-group select required dia_grupos_por_hora mt-2">
          <select
            className="select required custom_select form-control"
            style={{ width: '300px' }}
            name="dia[grupos_por_hora]"
            id="dia_grupos_por_hora"
            value={this.props.gruposPorHora}
            onChange={this.props.onChange}
          >
            <option value="1">Não dividir (Somente horário exato)</option>
            <option value="2">2 grupos (30 min)</option>
            <option value="3">3 grupos (20 min)</option>
            <option value="4">4 grupos (15 min)</option>
          </select>
        </div>
      </div>
    )
  }
}
